import type { JSX } from "react";
import {
  formatPeriod,
  type RunDescription,
} from "@/features/analytics/utils/runReport";

// The settings of the run the table shows, as one small muted line above it —
// from the SUBMITTED run, so it always describes the rows below, even after the
// configuration has been changed and not yet re-run. It reads like a hint, and
// clicking it opens the configuration.

const Item = ({
  label,
  children,
}: {
  label: string;
  children: string;
}): JSX.Element => (
  <span className="inline">
    <span className="font-semibold">{label}</span> {children}
  </span>
);

export const RunSummary = ({
  run,
  onOpenConfig,
}: {
  run: RunDescription | null;
  onOpenConfig: () => void;
}): JSX.Element => (
  <button
    type="button"
    onClick={onOpenConfig}
    // The visible settings are the accessible name; the title says what a
    // click does.
    title="Open the configuration"
    className="flex flex-wrap gap-x-3 gap-y-0.5 border-0 bg-transparent p-0 text-left text-[11.5px] text-(--text-muted) transition-colors hover:text-(--text-secondary)"
  >
    {run === null ? (
      "No report yet — click here or Configure to choose the settings and run it."
    ) : (
      <>
        <Item label="Period">{formatPeriod(run.from, run.to)}</Item>
        <Item label="Granularity">{run.granularity}</Item>
        <Item label="Source">{run.source}</Item>
        <Item label="Metrics">{run.metrics.join(", ")}</Item>
        <Item label="Group by">
          {run.groupBy.length > 0 ? run.groupBy.join(" → ") : "none"}
        </Item>
        <Item label="Sort">{run.sortBy.join(", ")}</Item>
        <Item label="Filters">
          {run.filters.length > 0
            ? run.filters.map((f) => `${f.label}: ${f.value}`).join("; ")
            : "none"}
        </Item>
      </>
    )}
  </button>
);
